import { FC } from 'react';
import { useState } from 'react';
import { ratingService } from '@/services/rating.service';
import styles from './RatingStars.module.scss';

interface IRatingStars {
  rating: number;
  title: string;
  id: number;
}

const RatingStars: FC<IRatingStars> = ({ rating, title, id }) => {
  const ALREADY_VOTED_BOOK_TXT = 'Вы уже оценили книгу ранее';
  const VOTED_BOOK_TXT = 'Cпасибо за отзыв.';

  let userBooks: string[] = [];

  const [isRatingActive, setIsRatingActive] = useState(false);
  const [isAlreadyVoted, setIsAlreadyVoted] = useState(false);
  const [isNoteVisible, setIsNoteVisible] = useState(false);
  const [userRatingNumber, setUserRatingNumber] = useState(0);

  //Достаем книги из localStorages
  if (typeof window !== 'undefined' && localStorage.getItem('userStorageBooks') !== null) {
    const getUserBooks = localStorage.getItem('userStorageBooks') || '';
    const getUserBooksString = JSON.parse(getUserBooks);

    userBooks.push(...getUserBooksString);
  }

  const fillRatingStar = (rating: number, starRate: number) => {
    if (rating >= starRate) {
      return styles.starsImg_active;
    }
  };

  const getRating = (event: React.MouseEvent<object>) => {
    if (!(event.target instanceof HTMLSpanElement)) {
      return;
    }

    /*Логика ui */
    if (isRatingActive === false && !userBooks.includes(String(id))) {
      const userRating = event.target.dataset.id;

      userBooks.push(String(id));
      localStorage.setItem('userStorageBooks', JSON.stringify(userBooks));

      setIsRatingActive(true);
      setIsAlreadyVoted(true);
      setUserRatingNumber(Number(userRating));
      setIsNoteVisible(true);

      setTimeout(() => {
        setIsNoteVisible(false);
      }, 2500);

      const data = {
        book_id: id,
        user_id: 1,
        voute_value: Number(event.target.dataset.id),
      };

      ratingService.postRating(data);
    } else {
      setIsAlreadyVoted(false);
      setIsNoteVisible(true);
      setTimeout(() => {
        setIsNoteVisible(false);
      }, 2500);
    }
  };

  const getRatingStarsElements = (ratingCounter: number) => (
    <span data-id="1" className={`${styles.starsImg} ${fillRatingStar(ratingCounter, 1)}`}>
      <span data-id="2" className={`${styles.starsImg} ${fillRatingStar(ratingCounter, 2)}`}>
        <span data-id="3" className={`${styles.starsImg} ${fillRatingStar(ratingCounter, 3)}`}>
          <span data-id="4" className={`${styles.starsImg} ${fillRatingStar(ratingCounter, 4)}`}>
            <span data-id="5" className={`${styles.starsImg} ${fillRatingStar(ratingCounter, 5)}`}></span>
          </span>
        </span>
      </span>
    </span>
  );

  return (
    <div onClick={getRating} className={styles.stars} {...(rating > 0 ? ({ itemType: 'http://schema.org/AggregateRating', itemScope: ' ', itemProp: 'aggregateRating' } as Record<string, unknown>) : {})}>
      {rating > 0 && (
        <>
          <span className={styles.hidden} itemProp="itemReviewed">
            {title}
          </span>
          <meta itemProp="worstRating" content="1" />
          <meta itemProp="bestRating" content="5" />
          <meta itemProp="ratingValue" content="{{ rateInt }}" />
          <meta itemProp="ratingCount" content="{{ book.voted_users }}" />
        </>
      )}

      {isRatingActive ? (
        <>
          {getRatingStarsElements(userRatingNumber)}
          <p className={styles.ratingTxt}>{userRatingNumber}</p>
          {!!isNoteVisible && !isAlreadyVoted && <p className={styles.voteNote}>{ALREADY_VOTED_BOOK_TXT}</p>}
        </>
      ) : (
        <>
          {getRatingStarsElements(rating)}
          {rating > 0 ? <p className={styles.ratingTxt}>{rating}</p> : <p className={`${styles.ratingTxt} ${styles.ratingTxt_zero}`}>0</p>}
          {!!isNoteVisible && <p className={styles.voteNote}>{ALREADY_VOTED_BOOK_TXT}</p>}
        </>
      )}
    </div>
  );
};

export default RatingStars;
